var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPwDefaultLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 80,
    viewBox: "0 0 57 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175 582C118 564-7 450 6 428c5-8 12-4 23 12 36 54 65 80 119 107 48 24 70 28 137 28 70 0 87-4 133-29 50-28 98-73 120-113 6-10 14-15 18-11 12 13-44 85-92 119-86 59-190 74-289 41z",
    transform: "matrix(.1 0 0 -.1 0 60)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181 543C89 510 10 397 10 300 10 161 136 40 280 40c46 0 106 15 123 30 12 11-34 151-46 143-6-4-8 0-4 9 3 9-1 27-8 42-13 24-12 26 9 26 19 0 26-11 45-72 13-40 28-78 33-85 6-7 5-19-2-33-10-19-10-20 7-12 31 18 71 65 92 112 54 119-2 269-124 332-54 28-164 34-224 11zm24-130V305l30-10c17-5 30-14 30-20 0-23 49-144 57-139 12 8 9-7-7-36l-13-25-10 25c-5 14-24 62-42 108l-31 82h-42c-33 1-38 3-24 11s17 25 17 109c0 69-4 100-12 103-7 3 1 6 17 6l30 1V413zm93 90c34-30 37-59 8-88-14-14-32-25-41-25-12 0-11 4 5 20 33 33 22 88-20 103-10 4-8 6 6 6 12 1 31-7 42-16zm196-228c-4-8-7-15-9-15s-5 7-9 15c-3 9 0 15 9 15s12-6 9-15z",
    transform: "matrix(.1 0 0 -.1 0 60)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 172c-5-8 16-36 56-75 48-48 76-67 117-80C279-15 377 0 464 59c48 34 104 106 92 119-4 4-12-1-18-11-22-40-70-85-120-112-46-26-64-29-133-30-60 0-91 5-125 21-47 21-104 71-131 113-11 17-18 21-23 13z",
    transform: "matrix(.1 0 0 -.1 0 60)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwDefaultLogo);
export default __webpack_public_path__ + "static/media/PwDefaultLogo.3c4776033c8abdb2aefa3d8a5d706eaf.svg";
export { ForwardRef as ReactComponent };